/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InputUavMissionWaypoint } from './InputUavMissionWaypoint';
import {
    InputUavMissionWaypointFromJSON,
    InputUavMissionWaypointFromJSONTyped,
    InputUavMissionWaypointToJSON,
} from './InputUavMissionWaypoint';

/**
 * 
 * @export
 * @interface InputGeoReverse
 */
export interface InputGeoReverse {
    /**
     * 
     * @type {Array<InputUavMissionWaypoint>}
     * @memberof InputGeoReverse
     */
    points: Array<InputUavMissionWaypoint>;
}

/**
 * Check if a given object implements the InputGeoReverse interface.
 */
export function instanceOfInputGeoReverse(value: object): boolean {
    if (!('points' in value)) return false;
    return true;
}

export function InputGeoReverseFromJSON(json: any): InputGeoReverse {
    return InputGeoReverseFromJSONTyped(json, false);
}

export function InputGeoReverseFromJSONTyped(json: any, ignoreDiscriminator: boolean): InputGeoReverse {
    if (json == null) {
        return json;
    }
    return {
        
        'points': ((json['points'] as Array<any>).map(InputUavMissionWaypointFromJSON)),
    };
}

export function InputGeoReverseToJSON(value?: InputGeoReverse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'points': ((value['points'] as Array<any>).map(InputUavMissionWaypointToJSON)),
    };
}

